import { getEnvironmentLabel } from "@client/lib/environmentTint";
import { cn } from "@client/utils/cn";
import { initializeLogoTransitions } from "@client/utils/initializeLogoTransitions";

/**
 * An app's logo tile with the environment name ("staging" / "dev") written
 * across it in tinted environments — a color alone is easy to forget the
 * meaning of. The label is absolutely positioned INSIDE the tile so the app
 * bar's layout never rearranges around it (production renders pixel-identical
 * to the plain tile).
 */
export function EnvironmentBadgedLogo({
  icon: Icon,
  className,
}: {
  icon: React.ElementType<{ className?: string }>;
  className?: string;
}) {
  const label = getEnvironmentLabel();

  return (
    <div
      ref={initializeLogoTransitions}
      className={cn(
        "logo-color-transition bg-primary text-primary-foreground relative flex aspect-square size-8 items-center justify-center rounded-lg",
        className,
      )}
    >
      <Icon className="size-5" />
      {label != null && (
        <span className="pointer-events-none absolute inset-x-0 bottom-0 rounded-b-lg bg-black/60 text-center text-[7px] leading-[10px] font-semibold tracking-wide text-white uppercase">
          {label}
        </span>
      )}
    </div>
  );
}
